import FromAccountVnd from "@/components/common/from-adcount-vnd/FromAccountVnd";
import ApprovalInfo from "@/modules/transfer-money/transfer-international/components/ApprovalInfo";
import useSavingStore from "@/stores/SavingStore/savingStore";
import {
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  Group,
  Paper,
  rem,
  Text,
  Title,
} from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { beText } from "@/utils/beText";

interface Props {
  onSubmit?: () => void;
  onBackStepOne?: () => void;
  isLoadingOtp?: boolean;
}

const DepositSettlementStepTwo: React.FC<Props> = ({
  onSubmit,
  onBackStepOne,
  isLoadingOtp,
}) => {
  const { t } = useTranslation();
  const [stateSavingStore] = useSavingStore();

  return (
    <Box>
      <Grid gutter="lg">
        <Grid.Col span={12} md={7}>
          <Paper bg="white" p={20} radius={10} mb={20}>
            <Text fw={600} mb="20px">
              {t("BENEFICIARY_ACCOUNT")}
            </Text>
            <FromAccountVnd />
          </Paper>

          <Paper bg="white" p={20} radius={10}>
            {/* THÔNG TIN KHOẢN GỬI */}
            <Text fw={600} mb="sm">
              {t("DEPOSIT_INFORMATION")}
            </Text>

            <Grid gutter="md" align="flex-start">
              {/* Hàng 1 - Tên doanh nghiệp / Địa chỉ */}
              {stateSavingStore.infoSavingDeposit &&
                stateSavingStore.infoSavingDeposit.map((item) => (
                  <Grid.Col span={12} md={6} key={item.key}>
                    <Flex justify="space-between">
                      <Text fz="sm" c="dimmed">
                        {beText(item.name)}
                      </Text>
                      <Text fz="sm" fw={500}>
                        {beText(item.value)}
                      </Text>
                    </Flex>
                  </Grid.Col>
                ))}
            </Grid>

            <Divider my="sm" variant="dashed" />

            {/* THÔNG TIN TẤT TOÁN */}
            <Text fw={600} my="20px">
              {t("SETTLEMENT_INFORMATION")}
            </Text>

            <Grid gutter="md" align="flex-start">
              {stateSavingStore.transInfoDeposit &&
                stateSavingStore.transInfoDeposit.map((item) => (
                  <Grid.Col span={12} md={6} key={item.key}>
                    <Flex justify="space-between">
                      <Text fz="sm" c="dimmed">
                        {beText(item.name)}
                      </Text>
                      <Text fz="sm" fw={500}>
                        {beText(item.value)}
                      </Text>
                    </Flex>
                  </Grid.Col>
                ))}
            </Grid>
          </Paper>
        </Grid.Col>
        <Grid.Col span={12} md={5}>
          <ApprovalInfo />
        </Grid.Col>
      </Grid>
      <Group position="center" mt={rem(20)}>
        <Box
          style={{
            position: "fixed",
            bottom: 0,
            right: 0,
            width: "calc(100% - var(--mantine-navbar-width, 0px))",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
            boxShadow: "0px 5px 15px 0px #00000026",
            height: "76px",
            alignItems: "center",
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          <Flex>
            <Title fz={14}>{t("TOTAL_AMOUNT_RECEIVED_COLON")} </Title>
            <Title fz={14} c="#0171BB">
              102.250.000 VND
            </Title>
          </Flex>
          <Button
            type="submit"
            loading={isLoadingOtp}
            onClick={onSubmit}
            sx={() => ({
              width: "160px",
              backgroundColor: "#2A81D0",
              color: "white",
              borderRadius: "8px",
              padding: "8px 10px",
              cursor: "pointer",
              fontWeight: 400,
            })}
          >
            {t("NEXT")}
          </Button>
        </Box>
      </Group>
    </Box>
  );
};

export default DepositSettlementStepTwo;
